module.exports = __webpack_public_path__ + "static/media/Barry M. Goldwater - 1964.dbcc4051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Barry M. Goldwater - 1964.jpg
// module id = 443
// module chunks = 0